import { createAsyncThunk } from "@reduxjs/toolkit";
import API from "../../../../network/API";
import { DROP, RELEASE, TRADE } from "../../../../utils/constants";

export const getManagerTxns = createAsyncThunk(
  "/swap/managerTxns",
  async (data: any) => {
    try {
      const response = await API.post(
        "/shift-swap-transaction/txns/manager",
        data
      );
      return response.data;
    } catch (error) {}
  }
);

export const getMyTxns = createAsyncThunk("/swap/myTxns", async (data: any) => {
  try {
    const response = await API.post("/shift-swap-transaction/txns/me", {
      user: data.user,
    });
    return response.data;
  } catch (error) {
  }
});

export const getAvailPickups = createAsyncThunk(
  "/swap/pickups",
  async (data: any) => {
    try {
      const response = await API.post(
        "/shift-swap-transaction/txns/pickups",
        data
      );
      return response.data;
    } catch (error) {
    }
  }
);

export const getAvailTrades = createAsyncThunk(
  "/swap/trades",
  async (data: any) => {
    try {
      const response = await API.post(
        "/shift-swap-transaction/txns/trades",
        data
      );
      return response.data;
    } catch (error) {
    }
  }
);

export const getContent = createAsyncThunk(
  "/swap/content",
  async (data: any) => {
    try {
      var response = null;
      if (data.type === TRADE) {
        response = await API.post("/os_schedules_employee_shift/shifts", data);
      } else if (data.type === RELEASE) {
        response = await API.post("/os_employee_profile/employees", data);
      } else if (data.type === DROP) {
        return null;
      }

      return response?.data;
    } catch (error) {
    }
  }
);

export const confirmRequests = createAsyncThunk(
  "/swap/confirm",
  async (data: any) => {
    try {
      const response = await API.post("/shift-swap-transaction/txns/confirm", {
        request: data,
      });
      return response.data;
    } catch (error) {
    }
  }
);

export const tradeShift = createAsyncThunk("/swap/trade", async (data: any) => {
  try {
    const response = await API.post(
      "/shift-swap-transaction/trade/confirm",
      data
    );
    return response.data;
  } catch (error) {
  }
});

export const releaseShift = createAsyncThunk(
  "/swap/release",
  async (data: any) => {
    try {
      const response = await API.post(
        "/shift-swap-transaction/release/confirm",
        data
      );
      return response.data;
    } catch (error) {
    }
  }
);

export const getTradeShifts = createAsyncThunk(
  "/swap/shifts",
  async (data: any) => {
    try {
      const response = await API.post(
        "/shift-swap-transaction/trade/shifts",
        data
      );
      return response.data;
    } catch (error) {
    }
  }
);
